import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=200e1658&scoped=true"
var script = {}
import style0 from "./Profile.vue?vue&type=style&index=0&id=200e1658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e1658",
  null
  
)

export default component.exports